import SSVolumeControl from "./00-slideshare_volume_control";

function SSToolbar(config){
  this.config = config;

  // Clipping Checks
  this.isClippable = window.slideshare_object && window.slideshare_object.slideshow.is_clippable;

  this.GA_EVENTS = {
    'viewonss' : 'toolbar_viewonss',
    'zoomin' : 'toolbar_zoomin',
    'zoomout' : 'toolbar_zoomout',
    'viewfullscreen' : 'toolbar_fullscreen',
    'leavefullscreen' : 'toolbar_leavefullscreen',
    'gotolastslide' : 'goto_last_slide',
    'gotofirstslide' : 'goto_first_slide'
  };
  this.GA_EVENTS_SRC = {
    'previous' : 'toolbar_prev',
    'next' : 'toolbar_next'
  };

  this._init();
  // widths are based on toolbar template. Keep this in sync when styling changes happen in toolbar template
  this._ELEMENTS = this.getElements(config.elementOverrides);
  this._ELEMENT_PRIORITIES = {
    1 : ['nav'],
    5 : ['viewOnSS'],
    2 : ['fullScreen','leaveFullScreen'],
    3 : ['share'],
    4 : ['goToSlide'],
    6 : ['zoomButtons']
  };

  this._BUTTONS = this.getButtons({
    btnFirst: '#btnFirst',
    btnPrevious: '#btnPrevious',
    btnNext: '#btnNext',
    btnLast: '#btnLast',
    btnSS: '.btnSS',
    btnViewOnSS: '.btnViewOnSS',
    btnFullScreen: '#btnFullScreen',
    btnLeaveFullScreen: '#btnLeaveFullScreen',
    btnZoomOut: '#btnZoomOut',
    btnZoomIn: '#btnZoomIn',
    btnFind: '.btnFind',
    btnShare: '.btnShare',
    btnAudio: '.btnAudio',
    btnVolume: '.btnVolume'
  }, config.buttonOverrides);


  this._ELEMENT_VISIBILITY = {
    'share' : !this.config.disableShare,
    'fullScreen' : !this.config.disableFullScreen && !this.config.isFullScreen,
    'leaveFullScreen' : !this.config.disableLeaveFullScreen && this.config.isFullScreen,
    'viewOnSS' : this.config.enableViewSS,
    'zoomButtons' : this.config.enableZoomButtons || false,
    'nav' : !this.config.disableNav,
    'goToSlide' : !this.config.disableGoToSlide
  };

  // section of the toolbar where the element will be appearing
  this._ELEMENT_SECTION = {
    'nav' : 'one',
    'share' : 'two',
    'fullScreen' : 'two',
    'leaveFullScreen' : 'two',
    'goToSlide' : 'two',
    'viewOnSS' : 'one',
    'zoomButtons' : 'two'
  };

  //load viewOnSS btn width from UI
  var viewOnSSbuttonWidth = {'small': 29, 'normal': 88};

  if (this.config.playerType == 'document' || this.config.playerType === 'infographic'){
    this._ELEMENT_WIDTHS = {
      'nav' : 30, //keep it half of actual width 60
      'share' : 72,
      'fullScreen' : 24,
      'leaveFullScreen' : 24,
      'goToSlide' : 57,
      'viewOnSS' : viewOnSSbuttonWidth[this.config.toolbarClass],
      'zoomButtons' : 56
    };
    this._ELEMENT_SECTION.share = 'one';
  } else {
    this._ELEMENT_WIDTHS = {
      'nav' : 57, //keep it half of actual width 114
      'share' : 35,
      'fullScreen' : 24,
      'leaveFullScreen' : 24,
      'goToSlide' : 57,
      'viewOnSS' : viewOnSSbuttonWidth[this.config.toolbarClass]
    };
  }

  this.config.toolbarPadding = 6;
}

SSToolbar.prototype._init = function() {
  var container;

  if (this.config.show_image_player) {
    container = $('.toolbar');
  } else {
    container = $('<div class="toolbar"></div>').html(this.config.html)
      .appendTo(this.config.renderTo);
  }
  this.container = container;

  this.toolbarOnFullscreen = this.config.player_type === 'presentation' ||
    this.config.player_type === 'document';

  if (this.toolbarOnFullscreen) {
    this.$fullscreenTitleBanner = $('.j-fullscreen-title-banner');
  }

  this.$currSlide = this.container.find('.j-current-slide');
  this.$progressBar = this.container.find('.j-progress-bar');
  if (this.$progressBar.length) {
    this.initProgressBar();
  }

  this.totalSlideCount = this.config.totalSlideCount;
  this.config.toolbarClass = this._getToolbarClass();
  this.container.addClass(this.config.toolbarClass);

  if (this.config.enableViewSS){
    container.find('.btnViewOnSS').show();
  }

  if (this.config.isFullScreen){
    container.find('#btnFullScreen').hide();
    container.find('#btnLeaveFullScreen').show();
  }

  if (this.config.playerType === 'video'){
    this.volumeControl = new SSVolumeControl({
      container : container.find('.jspl_volume_control'),
      renderTo : container,
      trigger : container.find('.btnVolume'),
      player : this.config.renderTo
    });
    this.audioActive = true;
  }

  // bind events
  var that = this;
  container.find('.j-total-slides').text(this.totalSlideCount);

  $('.slide_container').on('mousemove', function (e) {
    if (that.prevCursorScreenX !== e.screenX &&
      that.prevCursorScreenY !== e.screenY) {
      that.prevCursorScreenY = e.screenX;
      that.prevCursorScreenY = e.screenY;
      that.showFullscreenToolbar(true);
    }
  });

  this.container.on('mouseover', function () {
    that.showFullscreenToolbar(false);
  });
};

SSToolbar.prototype.showFullscreenToolbar = function (fadeOut) {
  if (! (this.config.isFullScreen && this.toolbarOnFullscreen)) {
    return;
  }

  var fsElements = this.$fullscreenTitleBanner
    .add(this.container.closest('.toolbar_wrapper'));

  if (fsElements.is(':hidden')) {
    fsElements.fadeIn('fast');
  }

  clearTimeout(this.showFSElemsTimer);

  if (fadeOut) {
    this.showFSElemsTimer = setTimeout(function () {
      fsElements.fadeOut('fast');
    }, 3000);
  }
};

SSToolbar.prototype._initForNativeFullScreen = function(){
  this._ELEMENT_VISIBILITY.fullScreen = !this.config.disableFullScreen && !this.config.isFullScreen;
  this._ELEMENT_VISIBILITY.leaveFullScreen = !this.config.disableLeaveFullScreen && this.config.isFullScreen;
};

SSToolbar.prototype._getToolbarClass = function(){
  var toolbarClass = "";

  if (this.config.width < 400){
    toolbarClass = "small";
  }
  else{
    toolbarClass = "normal";
  }
  return toolbarClass;
};

SSToolbar.prototype.resetButtons = function(buttonCodes){
  this._unbindButtonHandler(buttonCodes);
  this._bindButtonHandler(buttonCodes);
};

SSToolbar.prototype.getElements = function(overrides){
  var container = this.container;
  var elementCodes = {
    'nav' : '.nav',
    'share' : '.btnShare',
    'fullScreen' : '#btnFullScreen',
    'leaveFullScreen' : '#btnLeaveFullScreen',
    'viewOnSS' : '.btnViewOnSS',
    'goToSlide' : '.goToSlideLabel',
    'zoomButtons' : '.docActions'
  };
  var elements = {};
  $.each(elementCodes, function(code, selector ){
    if(overrides && overrides[code]){
      elements[code] = $(overrides[code]);
    } else{
      elements[code] = container.find(selector);
    }
  });
  return elements;
};

SSToolbar.prototype.getButtons = function(buttonCodes, overrides){
  var that = this;
  var buttons = {};
  var customButtons = overrides;
  $.each(buttonCodes, function(button, selector){
    if(customButtons && customButtons[button]){
      buttons[button] = $(customButtons[button]);
    } else{
      buttons[button] = that.container.find(selector);
    }
  });
  return buttons;
};


SSToolbar.prototype.deactivate = function(){
  var buttons = this._BUTTONS;

  $.each(buttons, function(code, button){
    button.unbind('click');
  });
  this._unbindButtonHandler(this._BUTTONS);

  this.container.find('.goToSlideLabel>input[type=text]').attr('disabled',true);
  this.active = false;
  if(this.config.playerType === 'video') {
    this._activateAudio();
  }
};

SSToolbar.prototype.activate = function(){
  var that = this;
  var container = this.container;

  this._bindButtonHandler({
    'btnViewOnSS' : 'viewonss',
    'btnFirst' : 'gotofirstslide',
    'btnSS' : 'viewonss',
    'btnPrevious' : 'previous',
    'btnNext' : 'next',
    'btnLast' : 'gotolastslide',
    'btnFullScreen' : 'viewfullscreen',
    'btnLeaveFullScreen': 'leavefullscreen',
    'btnZoomOut' : 'zoomout',
    'btnZoomIn' : 'zoomin',
    'btnFind' : 'playersearch',
    'btnShare' : 'playershare'
  });

  if (!this.isClippable) {
    this.activateProgressTooltip();
    this.$progressBar.on('click', function () {
      var position = parseInt(that.$tooltipSlideCount.text(), 10);
      $.slideshareEventManager.trigger('gotoslide', {index: position});
      $.slideshareEventManager.trackEvent('progressbar_click');
    });
  }

  this.active = true;

  if(this.config.playerType === 'video') {
    this._activateAudio();
  }
};

SSToolbar.prototype.updateAudioInteraction = function(values){
  var key;
  for(key in values){
    this[key] = values[key];
  }

  // directly calling only activate controls for video
  if(this.config.playerType === 'video') {
    this._activateAudio();
    return;
  }

  // @todo - this is a bit messy. Needs to be cleaned up.
  // This data is set via two places, one during componentset creations and via this method.
  if (this.active && this.audioReady && this.audioMetaReady){
    !this.audioActive && this._activateAudio();
    this._updateAudioDisplay();
  } else {
    this.audioActive && this._deactivateAudio();
  }
};

SSToolbar.prototype._activateAudio = function(){
  this.container.find('.btnAudio,.btnVolume').removeClass('disabled');
  this._bindButtonHandler({
    'btnAudio' : 'toggleaudio',
    'btnVolume' : 'showvolumecontrol'
  });
  this.audioActive = true;
};

SSToolbar.prototype._deactivateAudio = function(){
  this.container.find('.btnAudio,.btnVolume').addClass('disabled');
  this._unbindButtonHandler({
    btnAudio: null,
    btnVolume: null
  });
  this.audioActive = false;
};

SSToolbar.prototype._updateAudioDisplay = function(playing){
  if (this.audioPlaying){
    this.container.find('.btnAudio').removeClass('btnAudioPlay').addClass('btnAudioPause').attr('title','Pause');
  } else {
    this.container.find('.btnAudio').removeClass('btnAudioPause').addClass('btnAudioPlay').attr('title','Play');
  }
};

SSToolbar.prototype._bindButtonHandler = function(config){
  var that = this;
  $.each(config, function(buttonCode, eventname){
    var button = that._BUTTONS[buttonCode];
    if(!button){
      return;
    }
    button.unbind();
    button.bind('click', function(e){
      e.preventDefault();
      var ga_evt_src = that.GA_EVENTS_SRC[eventname];
      $.slideshareEventManager.trigger(eventname,{source : ga_evt_src});
      var gaEvent = that.GA_EVENTS[eventname];
      if (gaEvent){
        $.slideshareEventManager.trackEvent(gaEvent);
      }
    });
  });
};

SSToolbar.prototype._unbindButtonHandler = function(buttons){
  var that = this;
  $.each(buttons, function(buttonCode){
    var button = that._BUTTONS[buttonCode];
    button.unbind();
    button.bind('click', function(e){
      e.preventDefault();
      e.stopPropagation();
    });
  });
};

SSToolbar.prototype.setDimensions = function(dimensions){
  var that = this;
  /*
  available width for a section
  as the topmost priority element is placed first in the middle
  subtracting its width for each section
  */
  var firstElementWidth = that._ELEMENT_WIDTHS[that._ELEMENT_PRIORITIES[1][0]] ;
  var sectionWidth = (dimensions.width/2) - that.config.toolbarPadding - firstElementWidth ;
  var availableWidth = {
    'one' : sectionWidth,
    'two' : sectionWidth
  };
  var priorityLength = this._ELEMENT_PRIORITIES.length;
  var priorityElement, priorityElementLength;
  var elementCode, elementWidth, elementVisibility, elementShowable;
  $.each(this._ELEMENT_PRIORITIES, function(priority, priorityElement){
    // start showing toolbar items in order of priority
    // priorityElement = this._ELEMENT_PRIORITIES[i];
    priorityElementLength = priorityElement.length;
    for (var j=0; j<priorityElementLength; j++){
      // get width of the element.
      elementCode = priorityElement[j];
      var section = that._ELEMENT_SECTION[elementCode];
      elementWidth = that._ELEMENT_WIDTHS[elementCode];
      // check if sufficient width is available and if the element is showable
      elementShowable = ( that._ELEMENT_VISIBILITY[elementCode] && availableWidth[section] > elementWidth);
      if (priority == 1 || elementShowable){
        // show if available
        that._ELEMENTS[elementCode].show();
        // dont subtract if it is the first element
        // @todo better logic for this
        if (priority != 1){
          availableWidth[section] -= elementWidth;
        }
      } else {
        // hide if not available
        that._ELEMENTS[elementCode].hide();
      }
    }
  });
};

SSToolbar.prototype.updateCurrentPosition = function(position){
  this.handleDisabledButtons(position);
  this.$currSlide.text(position);
};

/**
 * handleDisabledButtons() will disable/enable buttons appropriately
 *   (e.g. disable prev button on first slide)
 *
 * @param <Numeric> position - current slide position
 */
SSToolbar.prototype.handleDisabledButtons = function (position) {
  this._BUTTONS.btnPrevious.removeAttr('disabled');
  if (position === 1) {
    this._BUTTONS.btnPrevious.prop('disabled', true);
  }
};


SSToolbar.prototype.destroy = function(){
  this.container.remove();
};

/**
 * updateProgressBar() will update the slideshow progress bar above the toolbar
 */
SSToolbar.prototype.updateProgressBar = function() {
  if (!this.$slidesLoadedBar) {
    return;
  }

  var progress = this.$currSlide.text() / this.totalSlideCount * 100;
  this.$slidesLoadedBar.width(progress + '%');
};

/**
 * initProgressBar() will initialize progress bar selectors and bind the
 *   following events:
 *     - Show the tooltip with the correct slide number when hovering
 *     - Hide the tooltip when we stop hovering over the bar
 *     - Jump to correct slide with a progress bar click
 */
SSToolbar.prototype.initProgressBar = function () {
  var that = this;

  this.$slidesLoadedBar = this.$progressBar.find('.j-slides-loaded-bar');
  this.$progressToolTip = this.$progressBar.find('.j-progress-tooltip');
  this.$toolTipContent = this.$progressToolTip.find('.j-tooltip-content');
  this.$toolTipThumb = this.$toolTipContent.find('.j-tooltip-thumb');
  this.$tooltipSlideCount = this.$progressToolTip.find('.j-slidecount-label');

  this.$tooltipSlideCount.text(this.$currSlide.text());

  // If experiments are present and the clipping experiment is truthy,
  // exclude the normal progress bar hover preview.
  if (!this.isClippable) {
    this.$progressBar.on('mousemove', function(e) {
      that.displayProgressTooltip(e);
    });

    this.$progressBar.on('mouseleave', function() {
      that.hideProgressTooltip();
    });
  }
};

/**
 * displayProgressTooltip() will show the progress tooltip with the slide
 *   number that will be jumped to if the user clicks
 */
SSToolbar.prototype.displayProgressTooltip = function (event) {
  var barOffsetX = this.$progressBar.offset().left;
  var adjustedCursorX = event.pageX - barOffsetX;
  var barWidth = this.$progressBar.width();
  // Math.max(1, ...) b/c should never show slide 0
  var slideAtCursor = Math.max(1, Math.ceil(adjustedCursorX / barWidth * this.totalSlideCount));
  var tooltipWidth = this.$progressToolTip.outerWidth();

  // ... - tooltipWidth / 2 so tooltip is centered at cursor not left edge
  this.$progressToolTip.css('margin-left', adjustedCursorX - tooltipWidth / 2);

  this.$tooltipSlideCount.text(slideAtCursor);
  if (this.config.isEmbed) {
    this.fitTooltipInWindow();
  }

  // Render tooltip thumbnail
  var tooltipThumbSrc = this.$toolTipThumb.attr('slide-thumb-' + slideAtCursor);
  this.$toolTipThumb.attr('src', tooltipThumbSrc);

  this.$progressToolTip.show();
};

/**
 * Updates the toolbar nav with the new href and slide for Bamboo Leaf
 *
 * @opts  next_ind [Fixnum] the new slide index of the 'next' button
 *        prev_ind [Fixnum] the new slide index of the 'previous' button
 *        next_href [Fixnum] the new href of the 'next' button
 *        prev_href [Fixnum] the new hrefof the 'previous' button
 */
SSToolbar.prototype.updateBamboo = function(opts) {
  var $next = this._BUTTONS.btnNext.find('a');
  var $prev = this._BUTTONS.btnPrevious.find('a');
  $next.data('slide', opts.nextInd);
  $next.attr('href', opts.nextHref);
  $next.attr('title', opts.nextTitle);
  $prev.data('slide', opts.prevInd);
  $prev.attr('href', opts.prevHref);
  $prev.attr('title', opts.prevTitle);
};

/**
 * fitTooltipInWindow() prevents the tooltip from going off the screen's edge
 */
SSToolbar.prototype.fitTooltipInWindow = function () {
  this.$toolTipThumb.css({
    'margin-left': 0,
    'margin-right': 0
  });

  this.$tooltipSlideCount.css({
    'margin-left': 0,
    'margin-right': 0,
    'border-bottom-left-radius': 3, // Make sure these value match original
    'border-bottom-right-radius': 3 // border radius (.tooltip-thumb)
  });

  var thumbLeftX = this.$toolTipThumb.offset().left;
  var thumbRightX = thumbLeftX + this.$toolTipThumb.outerWidth();
  var countLeftX = this.$tooltipSlideCount.offset().left;
  var countRightX = countLeftX + this.$tooltipSlideCount.outerWidth();
  var windowWidth = $(window).width();

  if (thumbLeftX < 0) {  // if left edge of thumbnail goes off screen
    // set margin left to width of thumbnail that goes off to keep left edge
    // exactly at screen's edge
    this.$toolTipThumb.css('margin-left', thumbLeftX * -1);
  } else if (thumbRightX > windowWidth) {
    // same logic for right side, but with x2 to adjust for centering
    this.$toolTipThumb.css('margin-left', (windowWidth - thumbRightX) * 2);
  }

  // same logic to keep tooltip on screen as thumbnail
  if (countLeftX < 0) {
    this.$tooltipSlideCount.css({
      'margin-left': (countLeftX) * - 1 - 1, // extra -1 because there is a gap
      'border-bottom-left-radius': 0 // so caret lies flush with body
    });

  } else if (countRightX > windowWidth) {
    this.$tooltipSlideCount.css({
      'margin-left': windowWidth - countRightX,
      'border-bottom-right-radius': 0 // so caret lies flush with body
    });
  }
};

/**
 * Deactivates the progress bar on mousemove
 */
SSToolbar.prototype.deactivateProgressTooltip = function () {
  if (this.$progressToolTip && this.$progressBar && !this.isClippable) {
    this.$progressToolTip.hide();
    this.$progressBar.off('mousemove');
    this.$progressBar.off('mouseleave');
  }
};

/**
 * Activates the progress bar on mousemove
 */
SSToolbar.prototype.activateProgressTooltip = function () {
  if (this.$progressToolTip && this.$progressBar && !this.isClippable) {
    this.deactivateProgressTooltip();
    this.$progressBar.on('mousemove', this.displayProgressTooltip.bind(this));
    this.$progressBar.on('mouseleave', function() {
      this.$progressToolTip.hide();
    }.bind(this));
  }
};

export default SSToolbar;
